import {
  RECEIVE_CONFIGS,
  RECEIVE_CONFIGS_ERROR
} from '../../actions/Login/consts'

const defaultState = {
  error: undefined,
  loaded: false,
  auth0Domain: undefined,
  auth0ClientId: undefined,
  auth0Audience: undefined
}

export default function OauthConfigReducer(state = defaultState, action) {
  switch (action.type) {
  case RECEIVE_CONFIGS:
    return { ...state,
      auth0Domain: action.config.auth0_domain,
      auth0ClientId: action.config.auth0_client_id,
      auth0Audience: action.config.auth0_audience,
      error: undefined,
      loaded: true }
  case RECEIVE_CONFIGS_ERROR:
    // Auth0Bootstrap gates its spinner on `loaded`, so a failed fetch must
    // still flip it — otherwise a network error spins the app forever.
    return { ...state, error: action.error, loaded: true }
  default:
    return { ...state }
  }
}
